function updateLanguageText() {
  console.log('Prueba')
    const langElement = document.querySelector(".small-hide span"); 
    if (!langElement) return;

    const langText = langElement.textContent.trim().toLowerCase();

    if (langText.includes("english")) {
        langElement.setAttribute("data-lang", "EN");
    } else if (langText.includes("español")) {
        langElement.setAttribute("data-lang", "ES");
    }
}

// Ejecutar cuando la página carga
document.addEventListener("DOMContentLoaded", updateLanguageText);

// Observar cambios en el selector
const observer = new MutationObserver(updateLanguageText);
observer.observe(document.body, { childList: true, subtree: true });

